import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'uploadFieldFolderPermissionsPanelError'
  | 'uploadFieldFolderPermissionsError'
  | 'uploadFieldFolderPermissionsBannerError'
  | 'metadataFieldError'
  | 'metadataErrorBannerMessage'
  | 'commonErrorBannerMessage';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  uploadFieldFolderPermissionsPanelError: {
    id: 'boxForms.builder.errors.uploadFieldFolderPermissionsPanelError',
    description:
      'Validation error message for upload field displayed in settings panel content field when user has insufficient permissions to use the folder',
    defaultMessage: 'Please select another folder.',
  },
  uploadFieldFolderPermissionsError: {
    id: 'boxForms.builder.errors.uploadFieldFolderPermissionsError',
    description:
      'Validation error message displayed inside the upload field within the Form Builder canvas when user insufficient permissions to use the folder',
    defaultMessage:
      'You no longer have access to this folder. Please select a new folder to proceed.',
  },
  uploadFieldFolderPermissionsBannerError: {
    id: 'boxForms.builder.errors.uploadFieldFolderPermissionsBannerError',
    description:
      'Validation error message displayed as notification toast banner when user insufficient permissions to use one ore more folders for file upload fields',
    defaultMessage:
      'You no longer have access to one or more folders for file upload fields. Please choose new folders to proceed.',
  },
  metadataFieldError: {
    id: 'boxForms.builder.errors.metadataFieldError',
    description:
      'Validation error message for metadata field in center builder panel when field does not exist in metadata template',
    defaultMessage:
      'The metadata template has changed and this field no longer exists. Please make changes.',
  },
  metadataErrorBannerMessage: {
    id: 'boxForms.builder.errors.metadataFolderErrorBannerMessage',
    description:
      'Validation error message displayed as notification toast banner for metadata field in builder when field does not exist in metadata template',
    defaultMessage:
      'One or more metadata templates tied to fields have changed.',
  },
  commonErrorBannerMessage: {
    id: 'boxForms.builder.errors.commonErrorBannerMessage',
    description:
      'Validation error message displayed as notification toast banner for common error in builder banner',
    defaultMessage: 'One or more fields are invalid or incomplete.',
  },
});

export default messages;
